"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTabs = void 0;
var UserTabs_1 = require("./UserTabs");
Object.defineProperty(exports, "UserTabs", { enumerable: true, get: function () { return UserTabs_1.UserTabs; } });
